import { CircularProgress } from "@mui/material";
import { useRef, useEffect, useState } from "react";

const SimpleMenuItems = ({
  containerClsNames = "mas-menu-container",
  itemClsNames = "mas-menu-item",
  items,
  open,
  onClose,
  menuId,
}) => {
  const menuRef = useRef(null);

  const [menuPosition, setMenuPosition] = useState("bottom");

  useEffect(() => {
    if (open && menuRef.current) {
      setTimeout(() => {
        if (!menuRef.current) {
          return;
        }

        const menuRect = menuRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Get the icon element that opened this menu
        const iconElement = document.querySelector(
          `[data-menu-id="${menuId}"]`
        );
        const iconRect = iconElement
          ? iconElement.getBoundingClientRect()
          : null;

        // Calculate available space below the icon
        const iconBottom = iconRect ? iconRect.bottom : menuRect.top;
        const spaceBelow = viewportHeight - iconBottom;
        const menuHeight = menuRect.height;

        // If menu would go off screen, show it above instead of below
        if (spaceBelow < menuHeight + 100) {
          setMenuPosition("top");
        } else {
          setMenuPosition("bottocm");
        }
      }, 0);
    } else {
      // Reset position when menu closes
      setMenuPosition("bottom");
    }
  }, [open, menuId]);

  useEffect(() => {
    function handleClickOutside(event) {
      // If clicking inside the menu, do nothing
      if (menuRef.current?.contains(event.target)) {
        return;
      }

      // If clicking on a different menu icon
      const clickedIcon = event.target.closest(".MuiSvgIcon-root");

      if (clickedIcon) {
        // Check if this icon belongs to this menu
        const iconDataId = clickedIcon.getAttribute("data-menu-id");

        // If it's our menu's icon, let it handle its own click
        if (iconDataId === menuId) {
          return;
        }

        // If it's a different menu's icon, close our menu
        onClose && onClose();

        return;
      }

      // It's a click elsewhere on the page, close the menu
      onClose && onClose();
    }

    // Only add the event listener if the menu is open
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener when component unmounts or when menu closes
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose, menuId]);

  // If no items are provided or the items array is empty, return nothing
  if (!items || items?.length === 0) {
    return <></>;
  }

  return (
    <>
      {open && (
        <div
          ref={menuRef}
          className={`${containerClsNames} ${menuPosition === "top" ? "mas-menu-top" : ""
            }`}
        >
          {items?.filter(item => !item?.hidden).map((item, index) => (
            <div
              key={index}
              className={`${itemClsNames} ${item?.disabled ? "disabled" : ""}`}
              onClick={(e) => {
                if (!item?.onClickFn) {
                  return;
                }

                item?.onClickFn(e);
              }}
            >
              {item?.label || ""}
              {item?.disabled && item?.showCircularSpinning && (
                <CircularProgress size={15} style={{ margin: "auto" }} />
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SimpleMenuItems;
